import React, { useEffect, useState } from "react";
import API from "../../../../services/api";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Loader from "@/components/loader";

export default function History({ project }) {
  const { id } = useParams();
  const [roadlogItems, setRoadlogItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusOnly, setStatusOnly] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      setLoading(true);
      const { data, ok } = await API.post("/roadlog_item/search", { project_id: id || project?._id });
      if (!ok) return toast.error("Error fetching roadlog items");
      setRoadlogItems(data);
    } catch (error) {
      console.error("Error fetching roadlog items:", error);
      toast.error("Error fetching roadlog items");
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <Loader />;

  let allLogs = roadlogItems
    .flatMap((item) => (item.logs || []).map((log) => ({ ...log, itemTitle: item.title, itemId: item._id })))
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  if (statusOnly) {
    allLogs = allLogs.filter((log) => log.field === "status");
  }

  return (
    <div className="p-2 flex flex-col gap-2 w-full">
      <div className="flex items-center gap-2 mb-4">
        <input type="checkbox" id="statusOnly" checked={statusOnly} onChange={(e) => setStatusOnly(e.target.checked)} className="rounded" />
        <label htmlFor="statusOnly" className="text-sm text-gray-600">
          Show only status changes
        </label>
      </div>
      {allLogs.map((log, index) => (
        <Log key={index} log={log} />
      ))}
    </div>
  );
}

function Log({ log }) {
  if (log.field === "status" && !log.old_value) {
    return (
      <div className="flex items-center gap-2 p-2 border rounded text-sm">
        <img src={log.user_avatar} alt={log.user_name} className="w-6 h-6 rounded-full" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1 text-gray-600">
            <span className="font-medium text-gray-900">{log.user_name}</span>
            <span>
              created the ticket ({log.itemTitle}) in {log.new_value}
            </span>
            <span className="text-xs ml-auto">{new Date(log.created_at).toLocaleString()}</span>
          </div>
        </div>
      </div>
    );
  }

  if (log.field === "status") {
    return (
      <div className="flex items-center gap-2 p-2 border rounded text-sm">
        <img src={log.user_avatar} alt={log.user_name} className="w-6 h-6 rounded-full" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1 text-gray-600">
            <span className="font-medium text-gray-900">{log.user_name}</span>
            <span>
              moved the ticket ({log.itemTitle}) from {log.old_value} to {log.new_value}
            </span>
            <span className="text-xs ml-auto">{new Date(log.created_at).toLocaleString()}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 p-2 border rounded text-sm overflow-y-auto">
      <img src={log.user_avatar} alt={log.user_name} className="w-6 h-6 rounded-full" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1 text-gray-600">
          <span className="font-medium text-gray-900">{log.user_name}</span>
          <span>modified</span>
          <span className="font-medium text-gray-900">{log.field}</span>
          <span>in</span>
          <span className="font-medium text-gray-900 truncate">{log.itemTitle}</span>
          <span className="text-xs ml-auto">{new Date(log.created_at).toLocaleString()}</span>
        </div>
        <div className="text-gray-600 mt-0.5">
          {log.text || (
            <span className="flex gap-2">
              <span>
                from <span className="font-medium">{log.old_value || "(empty)"}</span>
              </span>
              <span>
                to <span className="font-medium">{log.new_value || "(empty)"}</span>
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
